/* eslint-disable */

// BUG: Page flickering.
// * Every Webpack Build has webpack_modules variable that is used by __webpack_require__ during module resolving
// * We have 3 Different Webpack Builds (site_vendors, site_components, microsite) and 3 different webpack_modules objects with different set of modules inside
// * react-universal-component library uses __webpack_require__ under the hood when tries to resolve module syncronously (that is usually successful because such scripts loaded above on the page and are already inside the webpack_modules)
// * but since we have different webpack_modules then when react-universal-component tries to resolve the SSR module synchronously it fails because site_vendors webpack_modules don't have "CommonPDP" or "IrisCouponRouteLazy" or "IrisHomeRouteLazy", etc.
// * because such modules reside in the microsite webpack_modules but not in site_vendors webpack_modules
// * and since syncronous resolving fails then it goes to async resolving and async resolving returns promise and you see the flickering because promise is resolved only on the next tick
// * and the valid question "why do we need to comment the babel-plugin-universal-import/universalImport then?" and the answer is "because it uses react-universal-component under the hood"
// * as a solution i tried to extend site_vendors webpack_modules with site_components webpack_modules and with microsite webpack_modules but that approach doesn't work with react-universal-component library because when component is resolved the same site_vendors webpack_modules object would be pushed as "resolving function" into resolved component (CommonPDP, for example) and since we could extend site_vendors webpack_modules object only with one and only one module implementation we could face an error when site_components and microsite have the same module under the same name, for example LocalStorage. That module would be taken from site_vendors from site-components implementation and would fail because CommonPDP should use its own impelentation of LocalStorage there. So, the best option here is to have react-universal-component library duplicated in both bundles (it is small library) - site-components and microsite. So, commenting it
// require('react-universal-component');
// require('babel-plugin-universal-import/universalImport');

require('@babel/polyfill');
require('classnames');
require('classnames/bind');
require('es6-symbol/implement');
require('extend');
require('fetch-jsonp');
require('fontfaceobserver'); // Layout component uses FontLoader.jsx
require('history'); // used by yoda-app-shell/lib/client.jsx
require('isomorphic-fetch');
require('lodash/capitalize');
require('lodash/cloneDeep');
require('lodash/compact');
require('lodash/debounce');
require('lodash/defer');
require('lodash/each');
require('lodash/extend');
require('lodash/filter');
require('lodash/find');
require('lodash/findIndex');
require('lodash/flatten');
require('lodash/get');
require('lodash/has');
require('lodash/includes');
require('lodash/indexOf');
require('lodash/intersection');
require('lodash/isEmpty');
require('lodash/isEqual');
require('lodash/map');
require('lodash/merge');
require('lodash/noop');
require('lodash/omit');
require('lodash/take');
require('lodash/uniqueId');
require('lodash/values');
require('no-scroll'); // used by YodaFooter - ModalBox - ScrollLockHOC
require('qs');
require('react');
require('react');
require('react-circular-progressbar'); // React circular progress used in Header Account hover
require('react-dom');
require('react-fastclick-alt'); // CheckBox yoda-core-components that is used by FindAStorePage and ProductCard
require('react-redux');
require('react-router-dom');
require('redux');
require('redux-saga/effects');
require('reselect');
require('yoda-core-components/lib/polyfills');